export default __webpack_public_path__ + "static/media/industry-introduction.c80c8c5d.svg";